import React, { Component } from "react";
import { Link } from 'react-router-dom';

class Linktoother extends Component {
  render() {
    return (
      <div>
        <section className="breadcrumbs">
          <div className="container">
            <div className="row">
              <div className="col-sm-6 a-breadcrumbs" style={{color: '#ffffff'}}>
                <Link to="/home" className="a-breadcrumbs">หน้าแรก</Link>&nbsp;
                <i className="fa fa-angle-right" />&nbsp;<a href="#" className="a-breadcrumbs">บริการของเรา</a>&nbsp;
                <i className="fa fa-angle-right" />&nbsp;<a href="linktoother" className="a-breadcrumbs">Link หน่วยงานราชการที่เกี่ยวข้อง</a>
              </div>
            </div>
          </div>
        </section>

        <section className="page-section">
          <div className="container">
            <div className="row">
              <div className="col-md-9 col-sm-9 mb-sm-50">
                {/* section title*/}
                <h2 className="title-section mt-0 mb-0"><span>Link หน่วยงานราชการที่เกี่ยวข้อง</span></h2><br/>
                {/* ! section title*/}
                <div className="divider gray left mt-20 mb-25" />
                <a href="https://cpd.go.th/" target="_blank" className="cws-button" style={{fontSize: 19}}>กรมส่งเสริมสหกรณ์</a><br />
                <br />
                <a href="https://www.cad.go.th/main.php?filename=intro_20250214" target="_blank" className="cws-button" style={{fontSize: 19}}>กรมตรวจบัญชีสหกรณ์</a><br />
                <br />
                <a href="http://www.fsct.com/fsct_main.php" target="_blank" className="cws-button" style={{fontSize: 19}}>ชุมนุมสหกรณ์ออมทรัพย์แห่งประเทศไทย จํากัด</a><br />
                <br />
                <a href="https://www.clt.or.th/" target="_blank" className="cws-button" style={{fontSize: 19}}>สันนิบาตสหกรณ์แห่งประเทศไทย</a><br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
                <br />
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default Linktoother;
